import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ToastProvider } from './hooks/useToast';
import Layout          from './components/Layout';
import Login           from './pages/auth/Login';
import Register        from './pages/auth/Register';
import Dashboard       from './pages/Dashboard';
import ChartOfAccounts from './pages/ChartOfAccounts';
import Contacts        from './pages/Contacts';
import Products        from './pages/Products';
import OpeningBalances from './pages/OpeningBalances';
import Settings from './pages/Settings';
import Journals from './pages/Journals';
import Reports from './pages/Reports';
import Inventory from './pages/Inventory';
import Sales from './pages/Sales';
import SalesReturns from './pages/SalesReturns';
import PurchaseReturns from './pages/PurchaseReturns';
import Purchase        from './pages/Purchase';

const queryClient = new QueryClient();

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
};

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/"          element={<Navigate to="/dashboard" replace />} />
    <Route path="/login"     element={<PublicRoute><Login /></PublicRoute>} />
    <Route path="/register"  element={<PublicRoute><Register /></PublicRoute>} />
    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
    <Route path="/coa"       element={<PrivateRoute><ChartOfAccounts /></PrivateRoute>} />
    <Route path="/contacts"  element={<PrivateRoute><Contacts /></PrivateRoute>} />
    <Route path="/products"  element={<PrivateRoute><Products /></PrivateRoute>} />
    <Route path="/opening-balances" element={<PrivateRoute><OpeningBalances /></PrivateRoute>} />
    <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
    <Route path="/journals" element={<PrivateRoute><Journals /></PrivateRoute>} />
    <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
    <Route path="/inventory" element={<PrivateRoute><Inventory /></PrivateRoute>} />
    <Route path="/sales" element={<PrivateRoute><Sales /></PrivateRoute>} />
    <Route path="/sales-returns" element={<PrivateRoute><SalesReturns /></PrivateRoute>} />
    <Route path="/purchase-returns" element={<PrivateRoute><PurchaseReturns /></PrivateRoute>} />
    <Route path="/purchase"  element={<PrivateRoute><Purchase /></PrivateRoute>} />
    <Route path="*"          element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
















